<template>
    <div>
        <v-card-title v-if="!liveOnly" :class="[{'pt-3': $vuetify.breakpoint.smAndDown},
                               {'pt-2': $vuetify.breakpoint.mdAndUp}, 'px-3']">
            {{landesverbandLocal.name}} {{sportJahr.replace('_', '/')}}</v-card-title>
        <v-card-subtitle v-if="!liveOnly" class="px-3 pb-2">alle Spiele</v-card-subtitle>
        <div v-if="liveGamesCup.length>0 || liveGames.length>0">
            <v-row class="d-flex" no-gutters>
                <v-col class="grow" v-if="!liveOnly">
                    <div class="font-weight-bold mb-4 px-3 blue--text" style="width: 110px">
                        <div class="subtitle-1 my-0 font-weight-medium">Jetzt live ...</div>
                        <v-progress-linear rounded indeterminate color="blue">
                        </v-progress-linear>
                    </div>
                </v-col>
                <v-col class="grow text-right" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-text-field v-model="searchLive" prepend-inner-icon="mdi-magnify"
                                  label="Suchen" filled dense single-line hide-details
                                  :class="[{'mt-4': $vuetify.breakpoint.smAndDown},
                                  {'d-inline-block ml-3 mr-5': !liveOnly},
                                  {'mx-2': liveOnly}, 'mb-3']" color="blue">
                        <template v-slot:append>
                            <v-btn icon small class="pb-1">
                                <v-icon style="cursor: pointer" @click="searchLive=''">mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col class="pb-0 shrink" v-if="!liveOnly">
                    <v-btn color="blue" dark class="mr-3 my-0" @click="refreshList()">
                        <v-icon class="mr-2">mdi-refresh</v-icon>aktualisieren
                    </v-btn>
                </v-col>
            </v-row>
            <v-text-field v-if="$vuetify.breakpoint.smAndDown" v-model="searchLive"
                          prepend-inner-icon="mdi-magnify" color="blue"
                          label="Suchen" filled dense single-line hide-details
                          class="mx-3 mb-3" block>
                <template v-slot:append>
                    <v-btn icon small class="pb-1">
                        <v-icon style="cursor: pointer" @click="searchLive=''">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
            <div class="caption mx-3 mb-3">
                Klicke auf ein Team oder den Status um danach zu filtern, nochmaliges Klicken löscht den Filter.
            </div>
            <spiele-liste v-if="liveGamesCup.length>0" :headers="headersLiveCup" :spiele="liveGamesCup" hide-default-footer type="live"
                          @openSpielbericht="openSpielbericht" :search="searchLive" class="mb-5" :is-cup="true"
                          @quickSearch="quickSearchLive">
            </spiele-liste>
            <spiele-liste v-if="liveGames.length>0" :headers="headersLive" :spiele="liveGames" hide-default-footer type="live"
                        @openSpielbericht="openSpielbericht" :search="searchLive"
                        @quickSearch="quickSearchLive">
            </spiele-liste>
            <v-divider class="mt-7 mx-3"></v-divider>
        </div>
        <div v-if="!liveOnly">
            <v-row class="d-flex mt-7" no-gutters>
                <v-col class="pb-0 grow" >
                    <div :class="[{'mb-4': $vuetify.breakpoint.mdAndUp}, 'font-weight-bold  px-3']">
                        <div class="subtitle-1 pb-2 my-0 font-weight-medium">
                            Spielergebnisse pro Runde
                        </div>
                    </div>
                </v-col>
                <v-col class="text-right" v-if="$vuetify.breakpoint.mdAndUp" cols="4">
                    <v-text-field v-model="searchAll" prepend-inner-icon="mdi-magnify"
                                  label="Suchen" filled dense single-line hide-details
                                  class="mb-3 mr-5 d-inline-block">
                        <template v-slot:append>
                            <v-btn icon small class="pb-1">
                                <v-icon style="cursor: pointer" @click="searchAll=''">mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col class="shrink text-right pr-3 mb-3" style="min-width: 170px">
                    <v-select v-model="runde" :items="gespielteRunden" solo dense
                              label="Runde wählen" hide-details>
                        <template v-slot:no-data>
                            <span class="caption pa-3">Keine Daten vorhanden!</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mdAndUp" class="shrink text-right pr-3 mb-3">
                    <v-btn v-if="$vuetify.breakpoint.mdAndUp"
                           @click="print()" icon class="">
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-text-field v-if="$vuetify.breakpoint.smAndDown && spieleProRunde.length>0" v-model="searchAll"
                          prepend-inner-icon="mdi-magnify" class="mx-3 mb-3" block
                          label="Suchen" filled dense single-line hide-details>
                <template v-slot:append>
                    <v-btn icon small class="pb-1">
                        <v-icon style="cursor: pointer" @click="searchAll=''">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
            <div class="caption mx-3 mb-3" v-if="spieleProRunde.length>0">
                Klicke auf ein Team oder den Status um danach zu filtern, nochmaliges Klicken löscht den Filter.
            </div>
            <spiele-liste :headers="headersRunde" :spiele="spieleProRunde" hide-default-footer type="runde"
                          @openSpielbericht="openSpielbericht" :search="searchAll"
                          @quickSearch="quickSearchAll">
            </spiele-liste>
        </div>
        <spiel-bericht-edit-confirm v-if="$route.query.action==='displayErgebnis'" :set-realtime="true"
                                    :currentData="selectedSpiel" action="displayErgebnis">
        </spiel-bericht-edit-confirm>
    </div>
</template>

<script>
    //import {db} from "../../services/db"
    import SpieleListe from "./spieleListe";
    import SpielBerichtEditConfirm from "./spielbericht/edit/spielBerichtEditConfirm";
    //import {Spiel} from "../../services/data/spiel";

    export default {
        components: {
            SpielBerichtEditConfirm,
            SpieleListe},
        name: "spiele",
        props: ['saisonen', 'liveGames', 'sportJahr', 'lvId', 'liveOnly', 'liveGamesCup'],
        computed: {
            landesverbandLocal(){
                return this.lvId !== 'NationaleLigen' ? this.$store.state.local.landesverbaende
                        .find(lv => lv.nameShort.trim() === this.lvId) :
                    this.$store.state.local.nationaleLigen;
            },
            landesverband(){
                return this.$store.state.realtime.landesverbaende[this.landesverbandLocal.id];
            }
        },
        created(){
            this.computeRunden();
            //this.loadSpielIfSetInRoute();
        },
        data: () => ({
            headersLive: [ { text: 'liga', value: 'liga'},
                { text: 'Runde', value: 'runde', sortable: false},
                { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: false},
                { text: '', value: 'vs', align: 'center', sortable: false},
                { text: 'Gastteam', value: 'gastTeam', sortable: false},
                { text: 'Pkt', value: 'tabPktResult', sortable: false},
                { text: 'MaP', value: 'mpResult', sortable: false},
                { text: 'SaP', value: 'spResult', sortable: false},
                { text: 'Kegel', value: 'kegelResult', sortable: false, align: 'center' },
                { text: 'Stream/SpB', value: 'actions', sortable: false, align: 'center'},
                { text: '', value: 'statusText', sortable: false},
            ],
            headersLiveCup: [ { text: 'liga', value: 'liga'},
                { text: 'Runde', value: 'runde', sortable: false},
                { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: false},
                { text: '', value: 'vs', align: 'center', sortable: false},
                { text: 'Gastteam', value: 'gastTeam', sortable: false},
                { text: 'FW', value: 'fwResult', sortable: false, align: 'center' },
                { text: 'Abr.', value: 'arResult', sortable: false, align: 'center' },
                { text: 'Kegel', value: 'kegelResult', sortable: false, align: 'center' },
                { text: 'Stream/SpB', value: 'actions', sortable: false, align: 'center'},
                { text: '', value: 'statusText', sortable: false},
            ],
            headersRunde: [ { text: 'liga', value: 'liga'},
                { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: false},
                { text: '', value: 'vs', align: 'center', sortable: false},
                { text: 'Gastteam', value: 'gastTeam', sortable: false},
                { text: 'Pkt', value: 'tabPktResult', sortable: false},
                { text: 'MaP', value: 'mpResult', sortable: false},
                { text: 'SaP', value: 'spResult', sortable: false},
                { text: 'Kegel', value: 'kegelResult', sortable: false, align: 'center'},
                { text: 'SpB', value: 'actions', sortable: false, align: 'center'},
                { text: '', value: 'statusText', sortable: false},
            ],
            headersPrint: [ { text: 'liga', value: 'liga'},
                { text: 'Heimteam', value: 'heimTeam', align: 'right', sortable: false},
                { text: '', value: 'vs', align: 'center', sortable: false},
                { text: 'Gastteam', value: 'gastTeam', sortable: false},
                { text: 'Pkt', value: 'tabPktResult', sortable: false},
                { text: 'MaP', value: 'mpResult', sortable: false},
                { text: 'SaP', value: 'spResult', sortable: false},
                { text: 'Kegel', value: 'kegelResult', sortable: false, align: 'center'},
                { text: '', value: 'statusText', sortable: false},
            ],
            runde: '',
            gespielteRunden: ['1 H'],
            spieleProRunde: [],
            selectedSpiel: null,
            searchLive: null,
            searchAll: null,
        }),
        methods: {
            quickSearchLive(content){
                this.searchLive = this.searchLive === content ? '' : content;
            },
            quickSearchAll(content){
                this.searchAll = this.searchAll === content ? '' : content;
            },
            refreshList(){
                this.$emit('refreshLiveGames');
                setTimeout( () => {
                    this.$store.dispatch('clearSnackbar');
                    this.$store.state.globalSnack.color = 'blue';
                    this.$store.state.globalSnack.text = 'Die Spiele wurden neu geladen!';
                    this.$store.state.globalSnack.show = true;
                }, 500)
            },
            computeRunden(){
                this.gespielteRunden = [];
                this.spieleProRunde = [];
                this.runde = '';
                this.saisonen.forEach( (saison) => {
                    Object.keys(saison.spiele).forEach( (spielId) => {
                        let spiel = saison.spiele[spielId];
                        let runde = spiel.saison.runde + ' ' + spiel.saison.semester;
                        if ( spiel.saison.semester !== 'A' &&
                            spiel.vereine.heim.indexOf('confirmed') !== -1 &&
                            this.gespielteRunden.indexOf(runde) === -1) {
                            this.gespielteRunden.push(runde);
                        }
                    });
                });
                this.gespielteRunden.sort((a, b) => b > a ? 1 : -1);
            },
            filterSpieleByRunde(){
                this.spieleProRunde = [];
                this.saisonen.forEach( (saison) => {
                    if ( !this.landesverband.ligen[saison.ligaId].noRanking ) {
                        Object.keys(saison.spiele).forEach( (spielId) => {
                            let spiel = saison.spiele[spielId];
                            spiel.id = spielId;
                            if ( ( spiel.vereine.heim.indexOf('confirmed') !== -1 ||
                                    spiel.vereine.heim.indexOf('created') !== -1 ||
                                    spiel.vereine.heim.indexOf('pending') !== -1) &&
                                spiel.saison.runde + ' ' + spiel.saison.semester === this.runde ) {
                                spiel.liga = 'Runde ' + this.runde + '  /  ' + saison.local.title;
                                this.spieleProRunde.push(saison.getSpielForTable(spiel))
                            }
                        });
                    }
                });
            },
            async openSpielbericht(spiel){
                /*this.$store.state.local.loader = true;
                let fullSpiel = await this.getFullSpiel(spiel);
                this.selectedSpiel = new Spiel();
                this.selectedSpiel.setFromDataObject(fullSpiel);*/
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'displayErgebnis';
                q.spielId = spiel.id;
                //this.$store.state.local.loader = false;
                this.$router.push({path: p, query: q});
            },
            print(){
                if ( this.spieleProRunde.length === 0 ) {
                    this.$store.dispatch('clearSnackbar');
                    this.$store.state.globalSnack.timeout = 4000;
                    this.$store.state.globalSnack.color = 'primary';
                    this.$store.state.globalSnack.text = 'Die Liste der Spiele ist leer,' +
                        ' du kannst nichts drucken!';
                    this.$store.state.globalSnack.show = true;
                    return
                }
                let rundeLigaArray = [];
                this.saisonen.forEach( (saison) => {
                    if ( !this.landesverband.ligen[saison.ligaId].noRanking ) {
                        let rundeLiga = [];
                        Object.keys(saison.spiele).forEach( (spielId) => {
                            let spiel = saison.spiele[spielId];
                            spiel.id = spielId;
                            if ( ( spiel.vereine.heim.indexOf('confirmed') !== -1 ||
                                   spiel.vereine.heim.indexOf('created') !== -1 ||
                                    spiel.vereine.heim.indexOf('pending') !== -1) &&
                                spiel.saison.runde + ' ' + spiel.saison.semester === this.runde ) {
                                spiel.liga = 'Runde ' + this.runde + '  /  ' + saison.local.title;
                                rundeLiga.push(saison.getSpielForTable(spiel))
                            }
                        });
                        rundeLigaArray.push(rundeLiga);
                    }
                });
                this.$store.state.local.printContainer = {
                    header: !this.liveOnly ?
                            this.landesverbandLocal.name + ' ' + this.sportJahr.replace('_', '/') : '',
                    subheader: 'Runde ' + this.runde,
                    content: {
                        headersRunde: this.headersPrint,
                        rundeLigaArray: rundeLigaArray,
                        searchAll: this.searchAll,
                    },
                };
                this.$router.push({name: 'PrintSpiele',
                    query: {lvId: this.lvId}});
            },
            /*getFullSpiel(spiel){
                return new Promise( (resolve) => {
                    db.collection('spiele').doc(spiel.id).get()
                        .then((doc) => {
                            let spielTemp = doc.data();
                            spielTemp.id = doc.id;
                            resolve(spielTemp)
                        })
                        .catch((error) => {
                            console.error("Error deleting document: ", error);
                            resolve(spiel)
                        });
                })
            },*/
            /*async loadSpielIfSetInRoute(){
                if ( this.$route.query.spielId ) {
                    let fullSpiel = await this.getFullSpiel({id: this.$route.query.spielId, emptySpiel: true });
                    if ( fullSpiel.emptySpiel ) {
                        let p = JSON.parse(JSON.stringify(this.$route.path));
                        let q = JSON.parse(JSON.stringify(this.$route.query));
                        delete q.action;
                        delete q.spielId;
                        this.$router.replace({path: p, query: q});
                    }
                    this.selectedSpiel = new Spiel();
                    this.selectedSpiel.setFromDataObject(fullSpiel);
                }
            }*/
        },
        watch: {
            saisonen: {
                handler(){
                    this.computeRunden();
                },
                deep: true
            },
            runde(){
                this.filterSpieleByRunde();
            }
        }
    }
</script>

<style scoped>

</style>